import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './styles/tokens.css'
import './styles/global.css'
import './styles/app.css'
// Design directions (D-091). Each file is inert until ?theme=<name> sets data-theme.
import './styles/themes/field-guide.css'
import './styles/themes/arena.css'
import './styles/themes/sticker-book.css'
import './styles/themes/sticker-book-safari.css' // palettes: colour tokens only, after the base (D-103)
import './styles/themes/sticker-book-meadow.css'
import { applyTheme } from './lib/theme.js'

applyTheme()

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Offline support (SPEC 12): the app shell, roster and images are cached by the
// service worker; previously generated stories are kept in localStorage by lib/api.js.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}))
}
